module.exports = __webpack_public_path__ + "img/starship-freighter.541372a0.svg";